import * as types from "./actionTypes";
import criteriaTopsportApi from "../api/criteriaTopsportApi";
import * as constants from "../constants/DomainConstants";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";
import * as beads from "./beadActions";


// ----------------------------------------------------------------------------
export function criteriaTopsportLoaded(criteria, errors, hasValidationErrors) {
	return {
		type: types.CRITERIA_TOPSPORT_LOADED,
		body: {
			item: criteria,
			errors: errors,
			hasValidationErrors: hasValidationErrors
		}
	};
}

export function loadCriteriaTopsport(dossierId) {
	return (dispatch) => {
		dispatch(ajax.started());

		return criteriaTopsportApi.get(dossierId)
			.then(response => {
				dispatch(ajax.ended());
				dispatch(criteriaTopsportLoaded(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
				dispatch(beads.beadsLoaded(response.data.item.beadModels));
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

// ----------------------------------------------------------------------------
export function criteriaTopsportSaved(criteria, errors, hasValidationErrors) {
	return {
		type: types.CRITERIA_TOPSPORT_SAVED,
		body: {
			item: criteria,
			errors: errors,
			hasValidationErrors: hasValidationErrors
		}
	};
}

export function saveCriteriaTopsport(criteria, documenten) {
	return (dispatch) => {
		dispatch(ajax.started());
		return criteriaTopsportApi.save(criteria, documenten)
			.then((response) => {
				dispatch(ajax.ended());
				if (response.data.concurrencyException) {
					dispatch(criteriaTopsportSaved(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
					return constants.HAS_CONCURRENCY_EXCEPTION;
				}


				if (response.data.hasValidationErrors) {
					dispatch(criteriaTopsportSaved(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
					return constants.HAS_VALIDATION_ERRORS;
				}
				if (Object.keys(response.data.validationResults).length !== 0) {
					dispatch(criteriaTopsportSaved(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
					dispatch(beads.beadsLoaded(response.data.item.beadModels));
					return constants.HAS_VALIDATION_ERRORS_SAVED;
				}

				dispatch(criteriaTopsportSaved(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
				dispatch(beads.beadsLoaded(response.data.item.beadModels));
				return constants.SUCCESS;

			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}
